import styled from 'styled-components';

export const Filter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  padding: 0 30px;
`;
